import React, { useMemo, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom';
import WorkoutSection from './components/workout-section';
import ExercisesTable from './components/exercises-table-section';
import LoadingIndicator from '../../components/LoadingIndicator';
import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useGetWorkoutByIdQuery } from 'src/graphql';


const WorkoutScreen: React.FC = () => {

    const [URLSearchParams] = useSearchParams();
    const planId = useMemo(() => URLSearchParams.get('planId') || undefined, [URLSearchParams]);

    const { loading, data, error } = useGetWorkoutByIdQuery({
        variables: {
            workoutId: URLSearchParams.get('workoutId')!
        },
        skip: URLSearchParams.get('workoutId') === null,
        onError(data) {
            console.error("Error", data)
        }
    });
    const [workoutExerciseIndex, setWorkoutExerciseIndex] = useState(0);

    const { t } = useTranslation();

    if (loading) {
        return (
            <div className='h-screen flex items-center justify-center gap-2'>
                <LoadingIndicator />
                <span>{t("Please wait..")}</span>
            </div>
        );
    }

    if (error) {
        return <div>{error.message}</div>
    }

    return (
        <div className='space-y-6'>
            <WorkoutSection workoutExerciseIndex={workoutExerciseIndex} workout={data?.getWorkoutById as any} planId={planId} />
            <ExercisesTable onPressExercise={(index) => setWorkoutExerciseIndex(index)} workoutExercises={data?.getWorkoutById!.exercises!} />
        </div>
    )
}

export default WorkoutScreen;